import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import React from 'react';
import { useTestTileContext } from '../test-tile/context';
import useReportViewerContext from '../report-viewer-context';
import { getCustomFieldId, isCustomField } from '@app.raytd.com/common/utils/test-suites/getFieldRequirement';
import extractFieldValue from '@app.raytd.com/common/utils/test-suites/extractFieldValue';

interface MissingValueProps {
    field: string;
    showMissingData?: boolean;
}

const MissingValue = ({ field: field_id, showMissingData }: MissingValueProps) => {

    const { missingData, hasMissingData } = useTestTileContext();

    const missingFieldError = extractFieldValue(field_id, missingData);

    if (showMissingData && hasMissingData && missingFieldError) {
        return (
            <MissingPlaceHolder />
        )
    }

    //if development mode, show the missing data
    if (import.meta.env.DEV) {
        return <MissingBadge />
    }

    return <div>&nbsp;</div>;
}

export default MissingValue;

export const MissingBadge = React.memo(({ className }: { className?: string; }) => {
    return <Badge variant="outline" className={cn("", className)}>Missing</Badge>
});

export const MissingPlaceHolder = React.memo(({ className }: { className?: string }) => {
    return <div className={cn("w-full flex-1 bg-red-400 rounded-sm", className)}>&nbsp;</div>
});